import React, { useEffect, useState, useCallback, useContext } from "react";
import { useAuthContext } from "../../AuthContext";
import useUnityWrapper from "../../Hooks/PlayingScreen";
import {
  useNavigate,
  useLocation,
  unstable_HistoryRouter,
} from "react-router-dom";
import LoadingScreen from "../../component/Loader/LoadingScreen";
import ScoreScreen from "../../component/Score/Score";
import { PaymentValidation } from "../../component/Context/noteContext";
import { useMoralis } from "react-moralis";
import useScoreSubmit from "../../Hooks/CreateOrJoinGame";
import LoaderScreen from "../../component/CustomLoader/Loader";
import Quitpopup from "../../Pages/Playgame/QuitPopup/Quitpopup";

const NumberGameScreen = ({ gameValue, gameName }) => {
  const { Moralis } = useMoralis();
  let userId = Moralis?.User?.current()?.attributes?.ethAddress;
  console.log("user id", typeof userId);
  const {
    unityProvider,
    isLoaded,
    unload,
    Unity,
    addEventListener,
    removeEventListener,
    sendMessage,
    loadingProgression,
    requestFullscreen,
    UNSAFE__unityInstance,
  } = useUnityWrapper(gameName);
  const navigate = useNavigate();
  const props = useLocation().state;
  const [scoreState, setScore] = useState(0);
  const [gameType, setGameType] = useState();
  const [isGameOver, setIsGameOver] = useState(false);
  const [popupValue, setPopupValue] = useState(false);
  const { isMobile } = useAuthContext();

  const { setTransaction } = useContext(PaymentValidation);

  const { response_data, loading, callApi } = useScoreSubmit();

  const handleQuitGame = useCallback(async (score) => {
    console.log("score1", score);
    setScore(score);
    setPopupValue(true);
  });

  const resumeAgain = () => {
    window.unityInstance.SendMessage("PauseGameHandler", "ResumeGame", 12);
  };
  const handleGameOver = useCallback(async (score) => {
    console.log("score", score);
    const gameId = localStorage.getItem("gameId");
    const entryId = localStorage.getItem("entryId");
    if (score === undefined) {
      setScore(scoreState);
    } else {
      setScore(score);
    }
    setPopupValue(false);
    setIsGameOver(true);
    try {
      if (gameId !== -1) {
        callApi(localStorage.getItem("gameId"), {
          player_id: localStorage.getItem("user_id"),
          score: score === undefined ? scoreState : score,
          practice: props.practice && props.practice === true ? true : false,
        });
      }
      localStorage.setItem("transaction", false);
      setTransaction(false);
      if (gameId > 0) {
        setGameType("oneVone");
      }
      if (entryId > 0) {
        setGameType("tournament");
      }

      localStorage.setItem("gameId", -1);
      localStorage.setItem("entryId", -1);
    } catch (err) {
      console.log("error in submiting score", err);
    }

    unload();
  });
  useEffect(() => {
    return () => {
      setTransaction(false);
      unload();
    };
  }, []);

  useEffect(() => {
    window.unityInstance = UNSAFE__unityInstance;
  }, [UNSAFE__unityInstance?.Module]);

  useEffect(() => {
    addEventListener("GameOver", handleGameOver);
    addEventListener("QuitGame", handleQuitGame);
    return () => {
      removeEventListener("GameOver", handleGameOver);
    };
  }, [addEventListener, removeEventListener, handleGameOver]);

  useEffect(() => {
    if (isLoaded === true) {
      sendMessage("LoadLevelManager", "LoadLevel", gameValue);
    }
  }, [isLoaded, window.innerWidth, isMobile]);

  const setFullScreen = () => {
    requestFullscreen(true);
  };
  const loadingPercentage = Math.round(loadingProgression * 100);

  if (isGameOver === true && loading === false) {
    if (
      response_data?.data?.game?.winner &&
      response_data?.data?.game?.winner?.player === "player2"
    ) {
      navigate("/win", {
        state: { gameName: gameName, score: scoreState },
        replace: true,
      });
    } else if (
      response_data?.data?.game?.winner &&
      response_data?.data?.game?.winner?.player === "player1"
    ) {
      navigate("/loose", {
        state: { gameName: gameName, score: scoreState },
        replace: true,
      });
    } else {
      navigate("/score", {
        state: {
          scoreProp: scoreState,
          gametype: gameType,
          gameName: gameName,
          practice: props.practice && props.practice === true ? true : false,
        },
      });
    }
  } else {
    return (
      <div className="towerboxmain sec-height-global">
        <section className="towerBoxSection">
          <div className="container-1280">
            <div className={`numberboxgameparent ${props.gameClass}`}>
              <div className="game-window">
                <Unity
                  unityProvider={unityProvider}
                  className="gamebox-size"
                  width="100%"
                  height="100%"
                />
                {isLoaded ? (
                  <a
                    id="full-screen"
                    className="float-right full-screen"
                    onClick={() => {
                      setFullScreen();
                    }}
                  >
                    full
                  </a>
                ) : (
                  <div className="loader">
                    <LoadingScreen percent={loadingPercentage} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <Quitpopup
          open={popupValue}
          Quit={() => handleGameOver()}
          setValue={(value) => setPopupValue(value)}
          resume={() => resumeAgain()}
        />
      </div>
    );
  }
};

export default NumberGameScreen;
